module.exports = __webpack_public_path__ + "img/stop.253decb8.png";